import * as React from "react";
import { Check, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
const servicesData = [{
  title: "Junk Car Removal",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581925/img/junk_car_removal_dark.png",
  benefits: ["Free towing and removal", "Same-day pickup available", "Eco-friendly disposal"],
  link: "/ServicesPage"
}, {
  title: "Cash for Junk Cars",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581925/img/cash_for_cars_dark.png",
  benefits: ["Instant cash offers", "No hidden service fees", "Guaranteed price quotes"],
  link: "/ServicesPage"
}, {
  title: "Scrap Car Pickup",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581925/img/towing_24_7_dark.png",
  benefits: ["Fast response times", "Professional removal team", "Available across BC"],
  link: "/ServicesPage"
}, {
  title: "Scrap Car Recycling",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581925/img/scrap_car_disposal_dark.png",
  benefits: ["Eco-conscious processing", "All paperwork handled", "Any vehicle condition"],
  link: "/ServicesPage"
}];
export default function OurExpertSolutions() {
  return <section data-section-id="95177" id="our-specialized-services" className="dark bg-background text-foreground py-24 px-6 md:px-12 lg:px-24 relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_var(--color-primary)_0%,_transparent_50%)] opacity-10 pointer-events-none" />

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-serif font-bold tracking-tight mb-6 text-foreground uppercase">
            Our Specialized Services
          </h2>
          <p className="text-lg text-muted-foreground">
            Fast, reliable, and eco-friendly vehicle removal across British Columbia. We offer comprehensive scrap car recycling solutions designed to put instant cash in your pocket.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
          {servicesData.map((service, i) => <Card key={service.title} data-index={i} className="group relative overflow-hidden border-border/40 bg-card/40 backdrop-blur-md transition-all duration-500 hover:border-primary/50 hover:shadow-[0_0_40px_-10px_rgba(var(--color-primary),0.3)] flex flex-col">
              {}
              <div className="relative h-64 w-full overflow-hidden">
                <img src={service.image} alt={service.title} className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-110" />
                {}
                <div className="absolute inset-0 bg-primary/40 mix-blend-multiply transition-opacity duration-500 group-hover:opacity-60" />
                {}
                <div className="absolute inset-0 bg-gradient-to-t from-card via-card/10 to-transparent" />
              </div>

              <CardHeader className="relative z-10 -mt-8 pb-2 px-8">
                <CardTitle className="text-2xl font-serif text-foreground group-hover:text-primary transition-colors duration-300">
                  {service.title}
                </CardTitle>
              </CardHeader>

              <CardContent className="relative z-10 flex-grow px-8">
                <ul className="space-y-3 mt-4">
                  {service.benefits.map((benefit, index) => <li key={index} className="flex items-start gap-3 text-muted-foreground">
                      <Check className="w-5 h-5 text-primary shrink-0 mt-0.5" />
                      <span className="font-medium">{benefit}</span>
                    </li>)}
                </ul>
              </CardContent>

              <CardFooter className="relative z-10 pt-6 pb-8 px-8">
                <Button asChild variant="outline" className="w-full sm:w-auto border-primary/40 text-foreground hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all duration-300 group/btn rounded-sm">
                  <Link to={service.link}>
                    Get Started
                    <ArrowRight className="w-4 h-4 ml-2 transition-transform duration-300 group-hover/btn:translate-x-1" />
                  </Link>
                </Button>
              </CardFooter>
            </Card>)}
        </div>
      </div>
    </section>;
}